<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h5 class="modal-title">
      <span>Change Vehicle Selection</span>
    </h5>
  </div>
  <div class="modal-body">
      <p>{{ confirmationText }}</p>
  </div>
  <div>
    <div class="pt-2">
      <div class="row px-2 flex-nowrap fitter-row-position position-relative"></div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      (click)="confirm()"
      class="btn text-white"
      style="width: 80px"
    >
      <i class="fa fa-arrow-circle-right"></i>
      <span>OK</span>
    </button>
    <button type="button" class="btn btn-cancel" (click)="close()">
      Cancel
    </button>
  </div>
</ng-template>


